var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Bill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,2c0,0.552-0.448,1-1,1s-1-0.448-1-1h-2c0,0.552-0.448,1-1,1s-1-0.448-1-1h-2c0,0.552-0.448,1-1,1S9,2.552,9,2H7 c0,0.552-0.448,1-1,1S5,2.552,5,2H3v18c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2V2H19z M13,18H7v-2h6V18z M13,14H7v-2h6V14z M17,18h-2v-2h2V18z M17,14h-2v-2h2V14z M17,9H7V7h10V9z M19,20H5V5h14V20z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Bill);
export default __webpack_public_path__ + "static/media/icons8-bill.63db1c61.svg";
export { ForwardRef as ReactComponent };